import React from 'react';
import { componentService } from 'js/services/component.service';

export const SportsbookBetconstruct = React.lazy(() => import(/* webpackChunkName: "sportsbook-betconstruct" */ './SportsbookBetconstruct'));

componentService.registerPageComponents({ 'sportsbook-betconstruct': SportsbookBetconstruct });
